import { render, staticRenderFns } from "./IndustryTraining.vue?vue&type=template&id=716b6576&scoped=true&"
import script from "./IndustryTraining.vue?vue&type=script&lang=js&"
export * from "./IndustryTraining.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTraining.vue?vue&type=style&index=0&id=716b6576&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b6576",
  null
  
)

export default component.exports